export const dialog = () => {
	const dialogButtons = document.querySelectorAll('[data-dialog]')
	const closeButtons = document.querySelectorAll('.close-dialog')

	if (!dialogButtons.length) return

	dialogButtons.forEach(button => {
		button.addEventListener('click', () => {
			const dialogId = button.getAttribute('data-dialog')
			const targetDialog = document.getElementById(`dialog-${dialogId}`)

			if (targetDialog) {
				targetDialog.showModal()
			}
		})
	})

	closeButtons.forEach(button => {
		button.addEventListener('click', () => {
			const dialogId = button.getAttribute('data-dialog')
			const targetDialog = document.getElementById(`dialog-${dialogId}`)

			if (targetDialog) {
				targetDialog.close()
			}
		})
	})

	// Close dialog when clicking on backdrop
	const dialogs = document.querySelectorAll('dialog')
	dialogs.forEach(dialog => {
		dialog.addEventListener('click', (e) => {
			if (e.target === dialog) {
				dialog.close()
			}
		})

		// Prevent dialog content clicks from bubbling up
		const dialogContent = dialog.querySelector('*')
		if (dialogContent) {
			dialog.addEventListener('click', (e) => {
				if (e.target !== dialog) {
					e.stopPropagation()
				}
			})
		}
	})

	// Close dialog with Escape key (handled by browser automatically for modal dialogs)
}

export const accordion = () => {
	const accordionItems = document.querySelectorAll('[data-accordion]')

	if (!accordionItems.length) return

	accordionItems.forEach(item => {
		const trigger = item.querySelector('[data-accordion-trigger]')
		const content = item.querySelector('[data-accordion-content]')

		if (!trigger || !content) return

		// Set initial state
		const isOpen = item.hasAttribute('data-accordion-open')
		content.style.height = isOpen ? 'auto' : '0'
		item.classList.toggle('is-open', isOpen)

		trigger.addEventListener('click', (e) => {
			e.preventDefault()

			const isCurrentlyOpen = item.classList.contains('is-open')

			// Close all other accordion items
			accordionItems.forEach(otherItem => {
				if (otherItem !== item) {
					const otherContent = otherItem.querySelector('[data-accordion-content]')
					if (otherContent) {
						otherContent.style.height = '0'
						otherItem.classList.remove('is-open')
					}
				}
			})

			// Toggle current item
			if (isCurrentlyOpen) {
				content.style.height = '0'
				item.classList.remove('is-open')
			} else {
				// Get the full height
				content.style.height = 'auto'
				const fullHeight = content.scrollHeight + 'px'
				content.style.height = '0'

				// Force reflow then animate
				content.offsetHeight
				content.style.height = fullHeight
				item.classList.add('is-open')
			}
		})
	})
}